export enum Step {
  JobDetails = 0,
  SkillsEducation = 1,
  /** Only with the interviewer setup switched on (REACT_APP_INTERVIEWER_SETUP). */
  Interviewer = 2,
}

export enum WorkplaceType {
  HYBRID = 'HYBRID',
  REMOTE = 'REMOTE',
  ONSITE = 'ONSITE',
}
